import axios from "axios";
import {
  BASE_URL,
  DELETE_LETTER_USER,
  DOWNLOAD_LETTER,
  DOWNLOAD_LETTER_QR,
  DOWNLOAD_QR_CODE,
  GENERATE_FINAL_LETTER,
  LETTER,
  LOGIN,
  LOGOUT,
  RESEND_OTP,
  SA_LETTER_APPROVAL,
  SA_LETTERS_LIST,
  TRAINEE,
  TRAINEE_LIST,
  VERIFY_OTP,
  VISITOR,
  VISITOR_LIST,
  LETTER_REQUEST_APPROVAL,
  LETTER_TEMPLATE_CONTENT,
  DELETE_TOOL_ITEMS,
  STATE_LIST,
  CITY_LIST,
  CHANNEL_PARTNER,
  CHANNEL_PARTNER_LIST,
  ADD_CITY,
} from "./apiConstants";

const API = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

//To download invoice pdf, needs to pass responseType and headers
const API_FOR_QR = axios.create({
  baseURL: BASE_URL,
  responseType: "blob",
});

API.interceptors.request.use((req) => {
  if (localStorage.getItem("p")) {
    req.headers.token = JSON.parse(localStorage.getItem("p")).token;
  }
  return req;
});

API_FOR_QR.interceptors.request.use((req) => {
  if (localStorage.getItem("p")) {
    req.headers.token = JSON.parse(localStorage.getItem("p")).token;
  }
  return req;
});

// Login API
export const login_api = (loginData) => API.post(`${LOGIN}`, loginData);

// Logout API
export const logout_api = () => API.post(`${LOGOUT}`);

// verify otp
export const verify_otp = (bodyData) => API.post(`${VERIFY_OTP}`, bodyData);

// resend otp
export const resend_otp = (bodyData) => API.post(`${RESEND_OTP}`, bodyData);

//visitor list
export const visitor_list = (pageNum, searchString) =>
  API.get(VISITOR_LIST, {
    params: {
      page: pageNum,
      ...(searchString ? { searchString } : {}),
    },
  });
export const get_visitor_by_Id = (id, pageNum, searchString) =>
  API.get(`${VISITOR}${id}`, {
    params: {
      page: pageNum,
      ...(searchString ? { searchString } : {}),
    },
  });

// trainee List
export const trainee_list = (pageNum, filterParams, searchString) =>
  API.get(TRAINEE_LIST, {
    params: {
      page: pageNum,
      ...(filterParams?.filters ? { filtersJSON: filterParams.filters } : {}),
      ...(searchString ? { searchString } : {}),
    },
  });

// download QR code
export const download_qr_code = (traineeId) =>
  API_FOR_QR.get(`${DOWNLOAD_QR_CODE}${traineeId}`);

//trainee
export const add_trainee = (bodyData) =>
  API.post(TRAINEE, bodyData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
export const edit_trainee = (id, bodyData) =>
  API.patch(`${TRAINEE}${id}`, bodyData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
export const get_trainee_details_by_ID = (id) => API.get(`${TRAINEE}${id}`);
export const get_trainee_letter = (pageNum, filterParams, userID) =>
  API.get(`${TRAINEE}letter`, {
    params: {
      page: pageNum,
      ...(filterParams?.filters ? { filtersJSON: filterParams.filters } : {}),
      userID: userID,
    },
  });

//letter
export const create_letter = (formData) =>
  API.post(LETTER, formData, {
    responseType: "blob",
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

export const request_letter_approval = (id) =>
  API.patch(`${LETTER_REQUEST_APPROVAL}${id}`);

export const update_letter = (id, formData) =>
  API.patch(`${LETTER}${id}`, formData, {
    responseType: "blob",
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

export const delete_letter = (id) => API.delete(`${LETTER}${id}`);

export const letter_list = (pageNum, filterParams, searchString, userID) =>
  API.get(LETTER, {
    params: {
      page: pageNum,
      ...(filterParams?.filters ? { filtersJSON: filterParams.filters } : {}),
      ...(searchString ? { searchString } : {}),
      ...(userID ? { userID } : {}),
    },
  });

export const get_letter_by_ID = (id) => API.get(`${LETTER}${id}`);

export const get_letter_template_content = (filterParams) =>
  API.get(LETTER_TEMPLATE_CONTENT, {
    params: {
      ...(filterParams?.filters ? { filtersJSON: filterParams.filters } : {}),
    },
  });

export const delete_letter_user = (letterUserID) =>
  API.delete(`${DELETE_LETTER_USER}${letterUserID}`);

export const download__letter_qr = (id) =>
  API_FOR_QR.get(`${DOWNLOAD_LETTER_QR}${id}`);

export const download_letter = (id) =>
  API_FOR_QR.get(DOWNLOAD_LETTER, {
    params: {
      id: id,
    },
  });

export const generate_final_letter = (letterID) =>
  API.patch(`${GENERATE_FINAL_LETTER}${letterID}`);

// super admin api's
export const sa_letters_list = (pageNum, filterParams) =>
  API.get(SA_LETTERS_LIST, {
    params: {
      page: pageNum,
      ...(filterParams?.filters ? { filtersJSON: filterParams.filters } : {}),
    },
  });

export const letter_request_approval = (letterID, bodyData) =>
  API.patch(`${SA_LETTER_APPROVAL}/${letterID}`, bodyData);


export const delete_tool_items = (letterID, bodyData) =>
  API.patch(`${DELETE_TOOL_ITEMS}/${letterID}`, bodyData);

//channel-partner
export const add_channel_partner = (formData) =>
  API.post(CHANNEL_PARTNER, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

export const get_channel_partner_list = (pageNum, filters) =>
  API.get(CHANNEL_PARTNER_LIST, {
    params: {
      page: pageNum,
      ...(filters?.length ? { filtersJSON: filters } : {}),
    },
  });

export const get_channel_partner_by_id = (id) =>
  API.get(`${CHANNEL_PARTNER}${id}`);

export const update_channel_partner_by_id = (id, bodyData) =>
  API.patch(`${CHANNEL_PARTNER}${id}`, bodyData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

//city and state list
export const state_list = () => API.get(STATE_LIST);
export const city_list = (filtersJSON) =>
  API.get(`${CITY_LIST}`, {
    params: {
      filtersJSON,
    },
  });

export const add_city = (bodyData) => API.post(`${ADD_CITY}`, bodyData);